module.exports = __webpack_public_path__ + "img/nank.0406e4d6.png";